import React from 'react';
import { EIcons } from '../../../utils/globatTypes';
import { TitleBlock } from '../../TitleBlock';
import { BodyS, HeaderS, SubInfoS } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../../store/applicationState';
import { ShowUsers } from '../../../store/users/actions';
import { UserInfo } from '../../modals';
import { TInfoClient } from '../../../store/users/types';
import { UserList } from './UserList';
import { SearchUsers } from '../../Search';
import { setSideBar } from '../../../store/sidebar/actions';
import { OpenPrivateChat, PrivateChatActions } from '../../../store/privateChat/actions';
import { Loader } from '../../ui/Loader';

interface ParticipantsProps {}

export const Participants: React.FC<ParticipantsProps> = () => {
  const [client, setClient] = React.useState<TInfoClient | null | undefined>(null);
  const [clients, setClients] = React.useState<TInfoClient[] | null | undefined>(null);
  const [searchUsers, setSearchUsers] = React.useState<TInfoClient[] | null>(null);
  const [loading, setLoading] = React.useState(false);
  const { Sockets, Users } = useSelector((store: AppStore) => store);

  const { room } = Sockets;
  const { users, user } = Users;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (users && user) {
      const clients = users.filter((item) => item.id2 !== user.id2);
      setSearchUsers(clients);
      setClients(clients);
    }
  }, [users, user]);

  React.useEffect(() => {
    if (room) {
      dispatch(ShowUsers.request({ data: { event_id: room.event_id, roomId: room.absnum } }));
    }
  }, [dispatch, room]);

  const handleClick = (client: TInfoClient) => {
    if (room) {
      setLoading(true);
      dispatch(
        OpenPrivateChat.request({
          data: {
            event_id: room.event_id,
            roomId: room.absnum,
            userId: client.id2,
          },
          callBack: (success) => {
            setLoading(false);
            if (success) {
              dispatch(PrivateChatActions.setCurrentUserId2(client.id2));
              dispatch(setSideBar(EIcons.chat));
            }
          },
        })
      );
    }
  };

  return (
    <>
      <HeaderS>
        <TitleBlock title="Учасники" icon={EIcons.group} />
        <SubInfoS>
          <i style={{ fontSize: '20px', opacity: 0.5 }} className="ion-ios-people" />
          <span style={{ opacity: 0.6, padding: '0 0 0 5px', fontSize: '13px', fontWeight: 600 }}>{clients?.length}</span>
        </SubInfoS>
      </HeaderS>
      <SearchUsers users={clients} onChange={setSearchUsers} />
      <BodyS style={{ position: 'relative' }}>
        {searchUsers && searchUsers.length > 0 && (
          <UserList
            users={searchUsers}
            onClick={(client) => setClient(client as TInfoClient)}
            onWrite={(client) => handleClick(client as TInfoClient)}
          />
        )}{' '}
        {loading ? <Loader /> : null}
      </BodyS>
      {client && <UserInfo client={client} closeHandler={() => setClient(null)} />}
    </>
  );
};
